export default "__VITE_ASSET__7e767032__"